import PropTypes from "prop-types";

const HiFiWrapper = ({ children, title, isError, isModalWhiteSpaceNormal }) => {
  return (
    <div className="hifi-wrapper">
      {title && <span className={`hifi-wrapper-title hifi-wrapper-title-${isModalWhiteSpaceNormal ? 'normal' : ''}`}>{title}</span>}
      <div className={`hifi-wrapper-content ${isError ? 'hifi-wrapper-content-error' : ''}`}>
        {children}
      </div>
    </div>
  );
}

HiFiWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  isError: PropTypes.bool,
  isModalWhiteSpaceNormal: PropTypes.bool,
};

export default HiFiWrapper;